import reactDom from "react-dom";
import App from "./components/App";

reactDom.render(<App />, document.querySelector("#root"));
